export const ADD_LICENSE = "ADD_LICENSE";
export const ADD_LICENSE_SUCCESS = "ADD_LICENSE_SUCCESS";
export const EDIT_LICENSE = "EDIT_LICENSE";
export const EDIT_LICENSE_SUCCESS = "EDIT_LICENSE_SUCCESS";
export const DELETE_LICENSE = "DELETE_LICENSE";
export const DELETE_LICENSE_SUCCESS = "DELETE_LICENSE_SUCCESS";
export const GET_LICENSES = "GET_LICENSES";
export const GET_LICENSES_SUCCESS = "GET_LICENSES_SUCCESS";